import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const HomeSpeakerSplit = () => {
    return (
        <div className="rn-splite-style">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="col-lg-12 col-xl-6 col-12">
                        <div className="thumbnail image-left-content">
                            <img 
                                src="/images/speaking-pwu.jpg" 
                                alt="Speaking Outcomes" 
                                className="img-fluid rounded"
                            />
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <h4 className="title">Speaking Outcomes</h4>
                            </ScrollAnimation>
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <p className="description"></p>
                            </ScrollAnimation>
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <ol>
                                    <li> 100% clarity with a 3-step growth roadmap</li>
                                    <li> 90% take action within 24 hours</li>
                                    <li> 80% shift mindset in under 60 mins</li>
                                    <li> 70% boost execution with simple frameworks</li>
                                    <li> 20–50% grow income in 30–90 days</li>
                                </ol>
                            </ScrollAnimation>
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <div className="view-more-button mt--35">
                                    <Link className="btn-default" to="/speaker">SEE MORE</Link>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeSpeakerSplit;
